import { render, staticRenderFns } from "./ResourceMetricConfigurationPage.vue?vue&type=template&id=6461486d"
import script from "./ResourceMetricConfigurationPage.vue?vue&type=script&lang=ts"
export * from "./ResourceMetricConfigurationPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports